export const reportChangeAddressClick = () => ({
  event: 'change_address_clicked',
});
